var _style, _polygon, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrainwaveSymbolWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{display:none;opacity:0.17;fill:url(#SVGID_1_);enable-background:new    ;}\n\t.st2{fill:url(#SVGID_00000132788609278952347680000005309917156779211169_);}\n\t.st3{opacity:0.17;fill:url(#SVGID_00000137831958608992830530000002564095869984538504_);enable-background:new    ;}\n\t.st4{fill:#FFFFFF;stroke:#231F20;stroke-width:7.915807e-02;stroke-miterlimit:10;}\n\t.st5{opacity:0.24;fill:url(#SVGID_00000005986582461536712500000003465278901088307869_);enable-background:new    ;}\n\t.st6{fill:url(#SVGID_00000031906779955163810150000011921422681351017887_);}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "38.8,15.1 38.8,9.9 29.2,3.6 29.2,7.6 35.5,11.8 35.6,15 32.6,17 30.6,15.5 30.6,13.1 27.3,10.8  27.3,15.3 22.1,18.5 22.1,27 18.4,29 16.6,27.5 16.6,25.1 18.8,23.6 18.8,23.6 18.8,19.8 14.8,22.5 11.7,20.5 8.9,22.3 13.3,25.3  13.3,27.2 10.1,29.3 6.9,27.1 6.9,19.8 11.7,16.6 11.7,13.5 17.8,17.4 23,14 19.8,12.2 17.8,13.6 13.3,10.6 18.3,7.7 22.7,10.2  22.7,6.4 18.4,3.8 8.4,9.6 8.4,14.8 3.6,18.1 3.6,28.9 8.4,32.1 8.4,37.3 18,43.6 18,39.6 11.7,35.4 11.7,32.2 14.6,30.2 16.6,31.7  16.6,34.2 19.9,36.4 19.9,31.9 25.2,28.7 25.2,20.3 28.8,18.2 30.7,19.7 30.7,22.1 28.4,23.7 28.4,23.7 28.4,27.5 32.5,24.8  35.5,26.8 38.3,24.9 34,21.9 34,20.1 37.1,17.9 40.3,20.1 40.3,27.4 35.6,30.6 35.6,33.7 29.4,29.8 24.3,33.2 27.4,35 29.5,33.7  33.9,36.6 28.9,39.6 24.5,37 24.5,40.8 28.9,43.4 38.8,37.6 38.8,32.4 43.6,29.2 43.6,18.4 "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.3839,
    y1: 33.1895,
    x2: 48.1275,
    y2: 13.7919,
    gradientTransform: "matrix(1 0 0 -1 0 50)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05825046,
    style: {
      stopColor: "#532BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED34B3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.1,23.7c0-10.5-7.4-19.3-17.3-21.4c-0.8,0.2-1.5,0.5-2,0.7c-3.9,1.9-3.8,7.7-2.9,8.4 c0.9,0.6,16.5,12.5,16.7,10.5c0.2-1.9-0.7,8.2,2.8,13.6c1,1.5,1.8,2.8,2.6,4V23.7H46.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000086681156914896709480000013128953638274093234_",
    gradientUnits: "userSpaceOnUse",
    x1: 3.0986,
    y1: 33.2607,
    x2: 50.619,
    y2: 17.2511,
    gradientTransform: "matrix(1 0 0 -1 0 50)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#23007E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#2D0381"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000086681156914896709480000013128953638274093234_)"
    },
    d: "M46.1,23.7v0.2c0,0.2,0,0.4,0,0.7v21.8 c-3.6,0-6.8-2.2-8.1-5.4c-3.8,3.1-8.6,4.9-13.8,4.9H24C11.9,45.9,2.1,36.1,2.1,24v-0.2C2,11.5,11.8,1.7,23.9,1.7h0.2 C36.2,1.7,46.1,11.5,46.1,23.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000103244348996639196240000004679730699044835746_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.9567,
    y1: 34.264,
    x2: 46.9071,
    y2: 16.1766,
    gradientTransform: "matrix(1 0 0 -1 0 50)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05825046,
    style: {
      stopColor: "#532BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED34B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.17,
      fill: "url(#SVGID_00000103244348996639196240000004679730699044835746_)",
      enableBackground: "new"
    },
    d: " M46,24.5c0-0.2,0-0.4,0-0.7v-0.2c0-0.2,0-0.4,0-0.5s0-0.1,0-0.2s0-0.2,0-0.4c0-0.1,0-0.1,0-0.2s0-0.2,0-0.3c0-0.1,0-0.1,0-0.2 s0-0.2,0-0.3c0-0.1,0-0.1,0-0.2s0-0.2,0-0.3c0-0.1,0-0.1,0-0.2s0-0.3-0.1-0.4v-0.1c0-0.2-0.1-0.3-0.1-0.5v-0.1 c0-0.1,0-0.3-0.1-0.4c0-0.1,0-0.1,0-0.2s0-0.2-0.1-0.3c0-0.1,0-0.1,0-0.2s0-0.2-0.1-0.3c0-0.1,0-0.1-0.1-0.2 c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.3-0.1-0.4v-0.1 c-0.1-0.2-0.1-0.3-0.2-0.5c0-0.1,0-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3s-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3s-0.1-0.1-0.1-0.2 c0-0.1-0.1-0.2-0.1-0.3S44,14.5,44,14.4c0-0.1-0.1-0.2-0.1-0.3s-0.1-0.1-0.1-0.2c0-0.1-0.1-0.2-0.1-0.3s-0.1-0.1-0.1-0.2 c0-0.1-0.1-0.2-0.1-0.3c-0.1-0.1-0.1-0.3-0.2-0.4c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2 c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2c0-0.1-0.1-0.1-0.1-0.2 c0-0.1-0.1-0.1-0.1-0.2c-0.1-0.1-0.1-0.1-0.2-0.2l-0.1-0.1c-0.1-0.1-0.2-0.3-0.3-0.4l0,0c-0.1-0.1-0.2-0.3-0.3-0.4l-0.1-0.1 c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1-0.1C41,9.3,41,9.2,40.9,9.2l-0.1-0.1c-0.1-0.1-0.1-0.2-0.2-0.2l-0.1-0.1 c-0.4-0.2-0.5-0.3-0.6-0.4l-0.1-0.1c-0.4-0.4-0.8-0.8-1.2-1.2l0,0c-0.1-0.1-0.2-0.2-0.3-0.2l-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2 c0,0-0.1,0-0.1-0.1c-0.1-0.1-0.2-0.2-0.3-0.2c0,0,0,0-0.1,0c-0.7-0.5-1.4-1-2.2-1.5l0,0c-0.1-0.1-0.2-0.2-0.3-0.3l0,0 C34.4,4.2,34,4,33.5,3.8l0,0c-0.5-0.2-1-0.4-1.5-0.6l0,0c-0.5-0.2-1-0.4-1.5-0.5l0,0c-0.5-0.2-1.1-0.3-1.6-0.4l0,0 c-0.8,0.2-1.5,0.5-2,0.7c-3.9,1.9-3.8,7.7-2.9,8.4C24.8,12,38.1,22,40.4,22.2C39.6,24,38,30.7,43.2,35c1.4,1.1,2.3,1.5,2.9,1.3 L46,24.5L46,24.5z"
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 24,
    cy: 23.6,
    r: 13.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000009577405513725031440000001884881216167099056_",
    gradientUnits: "userSpaceOnUse",
    x1: 1.9844,
    y1: 23.4,
    x2: 12.7875,
    y2: 23.4,
    gradientTransform: "matrix(1 0 0 -1 0 50)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#534BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED34B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.24,
      fill: "url(#SVGID_00000009577405513725031440000001884881216167099056_)",
      enableBackground: "new"
    },
    d: " M7,27.6c-0.5-0.1-1-0.3-1.5-0.6c-1.3-0.8-2.1-2.3-2.1-3.9c0-1.4,0.7-2.7,1.7-3.5c0.2-0.1,0.3-0.3,0.5-0.4C6,18.9,6.4,18.4,6.7,18 c0.6-0.8,0.9-1.8,0.9-2.9c0-1.6-0.6-3-1.7-4c-2.5,3.6-4,7.9-4,12.6v0.2c0,7.6,3.8,14.2,9.6,18.2c0.7-1.4,1.1-3,1.2-4.7 C12.8,33.1,10.5,29.4,7,27.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("image", {
    style: {
      overflow: "visible",
      enableBackground: "new"
    },
    width: 99,
    height: 88,
    xlinkHref: "E516F75F.png",
    transform: "matrix(1 0 0 1 25.5433 -26.8032)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099653133826438347360000010686407360807644058_",
    gradientUnits: "userSpaceOnUse",
    x1: 16.3897,
    y1: 26.0237,
    x2: 42.9631,
    y2: 26.0237,
    gradientTransform: "matrix(1 0 0 -1 0 50)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#534BEE"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#ED34B3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099653133826438347360000010686407360807644058_)"
    },
    d: "M42.8,24.9c-0.3,1.2-1.3,2.2-2.5,2.5 c-1.1,0.3-2.3,0.1-3.1-0.4c-0.2-0.1-0.4-0.2-0.5-0.4c-0.2-0.2-0.3-0.3-0.5-0.5c0-0.1-0.1-0.1-0.1-0.2c-0.6-0.7-1.5-1.1-2.4-1.1 c-1.1,0-2.1,0.6-2.7,1.5c-0.1,0.2-0.3,0.5-0.4,0.8c-0.1,0.2-0.2,0.5-0.3,0.7c-2.1,3.4-6.8,5.1-11.3,2.1c-0.4-0.3-0.8-0.6-1-1 c-4-6,0.2-12.4,5.9-12.4c2.7,0,5.1,1.5,6.4,3.6c0.1,0.2,0.3,0.5,0.4,0.8c0.1,0.2,0.2,0.4,0.3,0.6c0.6,0.9,1.6,1.5,2.7,1.5 c1,0,1.8-0.4,2.4-1.1c0.1-0.1,0.1-0.1,0.2-0.2c0.2-0.3,0.4-0.5,0.7-0.7c0.1-0.1,0.2-0.2,0.3-0.2c0.6-0.4,1.3-0.6,2-0.6 C41.6,20.1,43.5,22.3,42.8,24.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrainwaveSymbolWhite);
export default __webpack_public_path__ + "static/media/brainwave-symbol-white.646bf397cea0125775994aacbf4bb0c3.svg";
export { ForwardRef as ReactComponent };